import React from 'react';
import Styled from './styled';

export type WidgetProps = {
    /** Children content to display inside the widget. */
    children: React.ReactNode;
};

/**
 * Widget component that wraps the ChatBot and includes the WidgetIcon.
 *
 * @param {WidgetProps} props - The properties to configure the Widget component.
 * @returns {JSX.Element} The rendered Widget component.
 */
export const Widget: React.FC<WidgetProps> = ({
    children,
}) => {

    return (
        <Styled.Widget>
            {children}
        </Styled.Widget>
    );
};